import httpManager from "@/app/shared/utils/httpManager";

async function parseJsonBlob(blob) {
  if (!(blob instanceof Blob)) return blob;

  try {
    return JSON.parse(await blob.text());
  } catch {
    return blob;
  }
}

function isTxtResponse(response) {
  const contentType = (response?.headers?.["content-type"] || "").toLowerCase();
  const contentDisposition = (response?.headers?.["content-disposition"] || "").toLowerCase();

  return (
    contentType.includes("text/plain") ||
    contentDisposition.includes(".txt")
  );
}

export async function validateTtsExcel(data, onUploadProgress) {
  try {
    const response = await httpManager.upload("/strategies/tts-excel-validation/", data, {
      onUploadProgress,
      responseType: "blob",
    });

    if (isTxtResponse(response)) {
      return {
        isTtsExcelValidationFile: true,
        response,
      };
    }

    return response?.data;
  } catch (error) {
    if (isTxtResponse(error?.response)) {
      error.isTtsExcelValidationFile = true;
      throw error;
    }

    if (error?.response?.data instanceof Blob) {
      error.response.data = await parseJsonBlob(error.response.data);
    }

    throw error;
  }
}
